/*
  Excise duty disclosure.

  Product prices on this store EXCLUDE excise duty, so each price carries an
  "excl. all taxes" toggle that opens a breakdown of what gets added at
  checkout. Liquid renders the maximum (federal + provincial); this file drops
  the provincial row for the three provinces that never joined the federal
  coordinated framework.

  It deliberately does NOT touch any price on the page. An earlier version
  rewrote prices to be duty-inclusive and had to fight Seal Subscriptions,
  discount-reveal and two currency-converter apps for control of the same
  nodes. Displaying rather than rewriting removes that entire class of problem.
*/
(function () {
  var FEDERAL_ONLY = ['BC', 'SK', 'NL'];   // [federal duty only - no provincial]

  var NAMES = {
    AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador', NS: 'Nova Scotia', NT: 'Northwest Territories',
    NU: 'Nunavut', ON: 'Ontario', PE: 'Prince Edward Island', QC: 'Quebec',
    SK: 'Saskatchewan', YT: 'Yukon'
  };

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function province() {
    try { return localStorage.getItem('userProvince') || ''; }
    catch (e) { return ''; }        // [private mode - assume the maximum]
  }

  function provincialApplies(p) {
    if (!p) return true;            // [unknown province shows the higher figure]
    return FEDERAL_ONLY.indexOf(p) === -1;
  }

  function apply() {
    var prov = province();
    var withProv = provincialApplies(prov);

    document.querySelectorAll('[data-allin]').forEach(function (node) {
      var base = parseInt(node.getAttribute('data-base'), 10) || 0;
      var duty = parseInt(node.getAttribute('data-duty'), 10) || 0;
      if (!duty) return;

      var row = node.querySelector('[data-allin-provrow]');
      if (row) {
        row.hidden = !withProv;
        var label = node.querySelector('[data-allin-provlabel]');
        if (label) {
          label.textContent = (prov && NAMES[prov] ? NAMES[prov] : 'Provincial') + ' excise duty';
        }
      }

      var total = node.querySelector('[data-allin-total]');
      if (total) total.textContent = money(base + duty + (withProv ? duty : 0));
    });
  }

  function wireToggles() {
    // Capture phase and preventDefault: on a collection card the whole tile is
    // wrapped in a link to the product, so a bubbling handler would open the
    // panel and then navigate away.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-allin-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var brk = btn.closest('[data-allin]').querySelector('[data-allin-brk]');
      if (!brk) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      brk.hidden = open;
    }, true);
  }

  function boot() { wireToggles(); apply(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  window.addEventListener('province:changed', apply);
  document.addEventListener('cart:updated', apply);
  // [Cards put into the page after load, e.g. a featured-collection tab opened for
  //  the first time. Unlike province:changed, this does not touch the cart.]
  document.addEventListener('allin:refresh', apply);
  // Cards can render late (quick-add modals, lazy grids).
  [400, 1200, 2500].forEach(function (t) { setTimeout(apply, t); });
})();
